
import { Vue, Component } from "vue-property-decorator";
import ContentHeader from "@/components/UIComponents/ContentHeader.vue";
import AppFooter from "@/components/UIComponents/AppFooter.vue";
import ContactPerson from "@/components/UIComponents/ContactPerson.vue";
import NewsCard from "@/components/UIComponents/NewsCard.vue";

@Component({
  components: { ContentHeader, AppFooter, ContactPerson, NewsCard },
  //   metaInfo(): MetaInfo {
  //     return {
  //       titleTemplate: 'Marketplace Home',
  //       meta: [
  //         { charset: "utf-8" },
  //         { name: "viewport", content: "width=device-width, initial-scale=1" }
  //       ]
  //     };
  //   }
})
export default class ContactScreen extends Vue {
  headerBackgroundUrl = "about.jpg";
}
